import { render } from "./cotacaofretesbase-list.vue?vue&type=template&id=d6199472"
import script from "./cotacaofretesbase-list.vue?vue&type=script&lang=js"
export * from "./cotacaofretesbase-list.vue?vue&type=script&lang=js"

import "./cotacaofretesbase-list.vue?vue&type=style&index=0&id=d6199472&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__